// Author Shi Wen Long
// Date 2021-10-29 11:40:55

class SithMesPrdPpNetwork {
constructor({
        id = null,
        network = '',
        parentId = '',
        salesOrderNum = '',
        wbs = '',
        tier = '',
        material = '',
        description = '',
        requireNum = '',
        basicUnit = '',
        elementNumber = '',
        elementProject = '',
        elements = '',
        receiptDate = '',
        buyerGroup = '',
        specialStock = '',
        requestElement = '',
        requireDate = '',
        prodOrderStatus = '',
        remark = ''}
= {}) {
    this.id = id;
    this.network = network;
    this.parentId = parentId;
    this.salesOrderNum = salesOrderNum;
    this.wbs = wbs;
    this.tier = tier;
    this.material = material;
    this.description = description;
    this.requireNum = requireNum;
    this.basicUnit = basicUnit;
    this.elementNumber = elementNumber;
    this.elementProject = elementProject;
    this.elements = elements;
    this.receiptDate = receiptDate;
    this.buyerGroup = buyerGroup;
    this.specialStock = specialStock;
    this.requestElement = requestElement;
    this.requireDate = requireDate;
    this.prodOrderStatus = prodOrderStatus;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpNetwork();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.network',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'salesOrderNum',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.salesOrderNum',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.wbs',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tier',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.tier',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'material',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.material',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'requireNum',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.requireNum',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'basicUnit',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.basicUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'elementNumber',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.elementNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'elementProject',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.elementProject',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'elements',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.elements',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'receiptDate',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.receiptDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'buyerGroup',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.buyerGroup',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'specialStock',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.specialStock',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'requestElement',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.requestElement',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'requireDate',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.requireDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prodOrderStatus',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.prodOrderStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'headerId',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.headerId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentHeaderId',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.parentHeaderId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpNetwork.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    networkFilter : '',
    parentIdFilter : '',
    headerIdFilter : '',
    headerIdInFilter : [],
    salesOrderNumFilter : '',
    wbsFilter : '',
    tierFilter : '',
    materialFilter : '',
    descriptionFilter : '',
    requireNumFilter : '',
    basicUnitFilter : '',
    elementNumberFilter : '',
    elementProjectFilter : '',
    elementProjectInFilter : [],
    elementsFilter : '',
    receiptDateRteFilter : '',
    receiptDateLteFilter : '',
    buyerGroupFilter : '',
    specialStockFilter : '',
    requestElementFilter : '',
    requireDateRteFilter : '',
    requireDateLteFilter : '',
    prodOrderStatusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'networkFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.network',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.parentId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'headerIdFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.headerId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'headerIdInFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.headerIdIn',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'salesOrderNumFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.salesOrderNum',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.wbs',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tierFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.tier',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.material',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requireNumFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.requireNum',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'basicUnitFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.basicUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elementNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.elementNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elementProjectFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.elementProject',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elementsFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.elements',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'receiptDateRteFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.receiptDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'receiptDateLteFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.receiptDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'buyerGroupFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.buyerGroup',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStockFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.specialStock',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requestElementFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.requestElement',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requireDateRteFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.requireDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'requireDateLteFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.requireDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'prodOrderStatusFilter',
        label: 'label.sith.prd.sithMesPrdPpNetwork.filter.prodOrderStatus',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.network',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'salesOrderNum',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.salesOrderNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tier',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.tier',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'material',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requireNum',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.requireNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'basicUnit',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.basicUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elementNumber',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.elementNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elementProject',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.elementProject',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'elements',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.elements',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'receiptDate',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.receiptDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'buyerGroup',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.buyerGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStock',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.specialStock',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requestElement',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.requestElement',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'requireDate',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.requireDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'prodOrderStatus',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.prodOrderStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpNetwork.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpNetwork, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
